import React from "react";
import { IFamilyTreeNode } from "../../interfaces";
import AddMemberButton from "../AddMemberButton/AddMemberButton";
import { Link } from "react-router-dom";
import { Avatar } from "antd";
import styled from "styled-components";
import { UserOutlined, SettingOutlined } from "@ant-design/icons";
import EditMemberButton from "../EditMemberButton/EditMemberButton";
import maleImg from "../../assets/img/male.png";
import femaleImg from "../../assets/img/female.png";
import AppTheme from "../../theme/AppTheme";

export declare type PersonNodeProps = {
  node: IFamilyTreeNode;
  elevated?: boolean;
  onChange?: () => void;
};

const AvatarIcon = styled(UserOutlined)`
  font-size: 6rem;
`;

const PersonNode: React.FC<PersonNodeProps> = (props) => {

  function getDefaultPicture() {
    switch (props.node.gender) {
      case "male":
        return maleImg;
      case "female":
        return femaleImg;
      default:
        return undefined;
    }
  }

  return props.node.suggestion ? (
    <div
      className={`w-full flex items-center justify-center flex-col text-center p-4${
        props.elevated === true
          ? " bg-white rounded-lg shadow-md"
          : "bg-transparent"
      }`}
    >
      <Avatar
        className="cursor-pointer w-24 h-24"
        size={"large"}
        shape="square"
        icon={<AvatarIcon />}
        src={getDefaultPicture()}
      />
      <AddMemberButton
        suggetion={props.node.suggestion}
        gender={props.node.gender}
        onSuccess={(person) => {
          if (props.onChange) props.onChange();
        }}
      />
    </div>
  ) : (
    <div
      className={`w-full flex items-center justify-center flex-col text-center p-4${
        props.elevated === true
          ? " bg-white rounded-lg shadow-md"
          : "bg-transparent"
      }`}
    >
      <span className="block font-bold text-base mt-2">
        {props.node.person ? (
          <>
            <Link
              className="block"
              to={`/person/${props.node.person.id}/details`}
            >
              <Avatar
                className="cursor-pointer w-24 h-24"
                size={"large"}
                shape="square"
                icon={<AvatarIcon />}
                src={getDefaultPicture()}
              />
            </Link>
            <span className="block py-2">
              <span className="inline-block">
                {`${[
                  props.node.person.last_name,
                  props.node.person.middle_name,
                  props.node.person.first_name,
                ].join(" ")}`}
              </span>
              <EditMemberButton
                className="ml-2 inline-block cursor-pointer"
                person={props.node.person}
                onSuccess={() => {
                  if (props.onChange) props.onChange();
                }}
                icon={
                  <SettingOutlined
                    style={{
                      fontSize: "1.25rem",
                      color: AppTheme.colors.primary,
                    }}
                  />
                }
              />
            </span>
          </>
        ) : (
          <span>Person Data Required</span>
        )}
      </span>
    </div>
  );
};

PersonNode.defaultProps = {
  elevated: false,
};

export default PersonNode;
